import React from "react";
import css from "./index.css";
import { connect } from "react-redux";
import mapDispatch from "~/misc/mapDispatch";
import { modalChange } from "~/modules/modal/actions";
import cs from "classnames"
const UnlockBtn = ({ onClick, isLoggedIn, showLogIn, isMobileHide}) => (
  <span
    className={cs(css.unlockBtn, {
      [css.mobile]: isMobileHide
    })}
    onClick={(e) => {
      e.stopPropagation();
      e.preventDefault();
      onClick();
    }}
  >
    <div className={css.unlockIcon}></div>
    {
      <span>UNLOCK</span>
    }
  </span>
);

export default connect(
  ({ user }) => ({ isLoggedIn: user.isLoggedIn }),
  mapDispatch({ showLogIn: () => modalChange("login", "rate-check") })
)(UnlockBtn);



// WEBPACK FOOTER //
// ./src/components/common/UnlockEst/index.js